import { useMe } from '@/routes/_app/use-me.ts';

export const StripeAccountStatus = {
  Created: 'Created',
  NotCreated: 'NotCreated',
  DetailsSubmitted: 'DetailsSubmitted',
  Configured: 'Configured',
};
export type StripeAccountStatus =
  (typeof StripeAccountStatus)[keyof typeof StripeAccountStatus];

export const useStripeAccountStatus = () => {
  const me = useMe();

  const stripeAccountCreated =
    !!me?.protectedFields?.stripeExpressSellerAccount;
  const stripeAccountDetailsSubmitted =
    !!me?.protectedFields?.stripeExpressSellerAccount?.props.detailsSubmitted;
  const stripeAccountConfigured =
    me?.protectedFields?.stripeExpressSellerAccount?.props.payoutsEnabled &&
    me?.protectedFields?.stripeExpressSellerAccount?.props.chargesEnabled;

  if (stripeAccountConfigured) {
    return { status: StripeAccountStatus.Configured };
  }

  if (stripeAccountDetailsSubmitted) {
    return { status: StripeAccountStatus.DetailsSubmitted };
  }

  if (stripeAccountCreated) {
    return { status: StripeAccountStatus.Created };
  }

  return { status: StripeAccountStatus.NotCreated };
};
